<template>
    <div style="width:85%;margin:auto;padding-top:10px;color:#7b7c87">
        
        <v-layout row wrap>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;padding-bottom:2px !important"><!--Row #1-->
                <v-layout row wrap>
                    <v-flex xs12 sm12 md10 lg10 xl10 style="padding:15px;padding-bottom:0px;">
                    <div style="padding-top:23px;font-weight:bolder;font-size:20px">مدیریت دسته بندی اخبار</div>
                    </v-flex>
                </v-layout>
            </v-flex>
            <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                <v-card>
                    <v-card-title>
                        <v-layout row wrap>
                            <v-flex xs12 sm12 md7 lg7 xl7 style="padding-right:15px;padding-left:15px;">
                                <v-text-field outlined dense color="#262d47" placeholder="جستجو" v-model="searchcategory" append-icon="fas fa-search"></v-text-field>   
                            </v-flex>
                            <v-flex xs12 sm12 md5 lg5 xl5 style="padding-right:15px;padding-left:5px;">
                                <v-btn outlined color="#4CAF50" @click="CatCreationDialog = true" dark><v-icon small style="padding-left:5px;">fa fa-plus</v-icon>&nbsp;دسته بندی جدید</v-btn>&nbsp;
                                <JsonExcel style="display: inline-block;padding-left: 5px;" :data="originalItems" :name="(Math.floor(Math.random() * (1254152541 - 1111 + 1)) + 1111).toString()" :fields="ExportDataColumns">
                                  <v-btn outlined color="#2a2d45" dark><v-icon small style="padding-left:5px;">fa fa-file-export</v-icon>&nbsp;دریافت اکسل</v-btn>&nbsp;
                                </JsonExcel>
                            </v-flex>
                        </v-layout>
                    </v-card-title>
                    <v-card-text>
                        <v-data-table no-data-text="رکوردی یافت نشد" no-results-text="رکوردی یافت نشد" :footer-props="{'items-per-page-text':'آیتم در هر صفحه :','items-per-page-all-text':'همه'}"  items-per-page-text="تعداد در هر صفحه" dense :loading="isLoadingCats" :headers="CatTableHeader" :search="searchcategory" :items="CatTableItems">
                            <template v-slot:[`item.nC_Status`]="{ item }">
                               <v-btn small text color="#D32F2F" @click="ActiveItem(item.nC_Id)" dark v-if="!item.nC_Status">غیر فعال</v-btn>
                               <v-btn small text color="#2E7D32" @click="DisableItem(item.nC_Id)" dark v-else> فعال</v-btn>
                            </template>
                            
                            <template v-slot:[`item.nC_Image`]="{ item }">
                                <v-btn target="_blank" :href="LogoUrl+`${item.nC_Image}`" icon small><v-icon small>fas fa-eye</v-icon></v-btn>
                            </template>
                            <template v-slot:[`item.operation`]="{ item }">
                                <v-btn text icon small color="blue accent-4" @click="editItem(item)"><v-icon small>fas fa-edit</v-icon></v-btn>
                                <v-tooltip color="purple accent-4" top >
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn v-bind="attrs" @click="LinkBoxSetting(item.nC_Id)" v-on="on" text icon small color="purple accent-4"><v-icon small>fas fa-link</v-icon></v-btn>&nbsp;
                                    </template>
                                    <span>باکس های لینک دار</span>
                                </v-tooltip>
                                <v-btn text icon small color="red accent-4" @click="confirmDeleteItem(item.nC_Id)"><v-icon small>fas fa-trash</v-icon></v-btn>&nbsp;
                            </template>

                        </v-data-table>
                    </v-card-text>
                </v-card>
            </v-flex>
        </v-layout>
        <template><!--Add New Cat From Dialog-->
            <v-dialog fullscreen persistent v-model="CatCreationDialog">
                <v-card>
                  <v-card-title style="padding:0px !important">
                      <v-app-bar dense color="rgb(42, 45, 69)" dark>
                          <v-toolbar-title style="color:orange">
                              <span v-if="!inEditingItem">ثبت دسته بندی جدید</span>
                              <span v-else>ویرایش دسته بندی  &nbsp; <v-btn small outlined color="red" @click="cancelEditItem"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp;لغو ویرایش</v-btn></span>
                          </v-toolbar-title>
                          <v-spacer></v-spacer>
                          <v-icon color="orange" @click="CatCreationDialog = false" small>fa fa-times</v-icon>
                      </v-app-bar>
                  </v-card-title>
                  <v-card-text>
                      <v-layout row wrap>
                          <v-flex xs12 md12 lg12 xl12 style="padding:15px;"><!--Row #2-->
                            <v-layout row wrap style="flex-wrap:wrap-reverse !important;">
                                <v-flex xs12 sm12 md4 lg4 xl4 style="padding:15px;padding-top:0px !important;border-left:1px solid rgb(200,200,200)"><!--Register New Cat From-->
                                    <div style="padding-top:23px;padding-bottom:5px;font-weight:bolder;font-size:17px">تنظیمات اصلی</div>
                                                                      
                                    <v-text-field color="#2a2d45" outlined dense v-model="CatTitle" label="عنوان دسته بندی" ></v-text-field>
                                   
                                    <v-text-field color="#2a2d45" outlined dense v-model="CatSortField" label="ترتیب نمایش"></v-text-field>
                                    
                                    <v-row>
                                        <v-col cols="8">وضعیت :</v-col>
                                        <v-col cols="4" style="display: flex;justify-content: flex-end;">
                                            <v-switch v-model="CatStatus" style="padding-top:0px !important;margin-top:0px !important" color="#2a2d45"></v-switch>
                                        </v-col>
                                    </v-row>
                                   
                                    <v-row>
                                        <v-col cols="5"><v-img contain width="48" class="PreviewLogoCropped" :src="catLogoData"></v-img></v-col>
                                        <v-col cols="7" style="display: flex;justify-content: flex-end;">
                                            <input accept="image/png,image/jpg,image/jpeg,image/gif" @change="catLogoSelectedEvt($event)" type="file" ref="catLogoSelectorRef" style="display:none"/>
                                            <v-btn outlined dark color="#7600b3" @click="$refs.catLogoSelectorRef.click()"><v-icon small style="padding-left:5px;">fa fa-image</v-icon>&nbsp; لوگو</v-btn>
                                        </v-col>
                                    </v-row>
                                  
                                    <v-btn @click="registerCategory" outlined dark block color="blue"><v-icon small style="padding-left:5px;">fa fa-check</v-icon>&nbsp; ذخیره</v-btn>
                                </v-flex>
                                <v-flex xs12 sm12 md8 lg8 xl8 style="padding:15px;padding-top:0px !important"><!--Seo Form-->
                                    <seo-form FileLoc="CONTENTSEO" :Seo="CatSeoModel"  @SeoData="SeoChanged"></seo-form>
                                </v-flex>
                            </v-layout>
                        </v-flex>
                      </v-layout>
                  </v-card-text>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Image Cropper Dialog-->
            <v-dialog max-width="600" style="overflow: hidden !important;" persistent v-model="catLogoSelectionDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">برش عکس</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="catLogoSelectionDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:10px;">
                        <v-alert dense type="info" outlined>
                            <div>کاربر گرامی ؛ </div>
                            <div>اندازه عکس دسته بندی بهتر است به صورت زیر باشد :</div>
                            <div>کمینه عرض : {{ALLOEWDIMGSIZE.minwidth}} پیکسل</div>
                            <div>بیشینه عرض : {{ALLOEWDIMGSIZE.maxwidth}} پیکسل</div>
                            <div>کمینه ارتفاع : {{ALLOEWDIMGSIZE.minheight}} پیکسل</div>
                            <div>بیشینه ارتفاع : {{ALLOEWDIMGSIZE.maxheight}} پیکسل</div>
                            <div>نسبت عرض به ارتفاع : {{ALLOEWDIMGSIZE.aspectratio}}</div>
                        </v-alert>
                        <div class="overFlowHidden">
                            <cropper previewClassname="PreviewLogoCropped" maxWidth="400" maxHeight="400" classname="cropper" :src="selectedLogoSource"  @change="change"></cropper>
                        </div>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined dark color="blue" @click="uploadEntityLogo"><v-icon small style="padding-left:5px;">fa fa-upload</v-icon>&nbsp; آپلود</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <template><!--Loading Dialog-->
            <div class="vld-parent">
                <loading color="#f75314" :width="parseInt(45)" :height="parseInt(45)" background-color="#fff" :active.sync="isLoading" 
                :is-full-page="true"></loading>
                
               
            </div>
        </template>
        <template><!--Delete Confirm Dialog-->
            <v-dialog max-width="450" persistent v-model="ConfirmItemDeleteDialog">
                <v-card>
                    <v-card-title style="padding:0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                            <v-toolbar-title style="color:orange">حذف دائمی</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-icon color="orange" @click="ConfirmItemDeleteDialog = false" small>fa fa-times</v-icon>
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text style="padding-top:15px;">
                        <v-alert type="error" outlined>
                            کاربر گرامی ؛ رکورد مورد نظر به همراه تمام زیر مجموعه های آن به صورت دائمی حذف خواهند شد.ادامه میدهید؟
                        </v-alert>
                    </v-card-text>
                    <v-divider></v-divider>
                    <v-card-actions>
                        <v-btn outlined :loading="deleteBtnLoading" color="error" @click="DeleteItem"><v-icon small style="padding-left:5px;">fa fa-trash</v-icon>&nbsp; بله</v-btn>&nbsp;
                        <v-btn outlined @click="ConfirmItemDeleteDialog = false" color="info"><v-icon small style="padding-left:5px;">fa fa-times</v-icon>&nbsp; خیر</v-btn>&nbsp;
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
        <template>
            <v-dialog fullscreen persistent v-model="SetPromotionBoxDialog">
                <v-card>
                    <v-card-title style="padding: 0px !important">
                        <v-app-bar dense color="rgb(42, 45, 69)" dark>
                        <v-toolbar-title style="color: orange">
                            <span>مدیریت باکس</span>
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-icon color="orange" @click="$router.go($router.currentRoute)" small
                            >fa fa-times</v-icon
                        >
                        </v-app-bar>
                    </v-card-title>
                    <v-card-text>
                        <PromotionBoxs :EntityId="EntityId" :Type="BoxType"></PromotionBoxs>
                    </v-card-text>
                </v-card>
            </v-dialog>
        </template>
    </div>
</template>

<style scoped>
.overFlowHidden .v-dialog:not(.v-dialog--fullscreen)
{
    overflow: hidden !important;
}
.overFlowHidden 
{
    max-width: 400px;
    max-height: 400px;
    overflow: hidden !important;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: auto;
}
</style>
<script>
import PromotionBoxs from '../../../components/forms/PromotionBox';
const axios = require("axios");
const ApiUrl = require('../../../constant/apiurl');
const MSGHNDL = require('../../../constant/MessageHandler');
const FTYPES = require('../../../constant/setting/Default/AllowedFileTypes');
const FSIZE = require('../../../constant/setting/Default/AllowedFileSize');
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import JsonExcel from 'vue-json-excel'
import { mapState, mapMutations, mapActions } from 'vuex'
export default {
    name:"newsCategory",
   components: {
            Loading,
            JsonExcel,
            PromotionBoxs
        },
    data:()=> ({
        ConfirmItemDeleteDialog:false,
        isLoading:false,
        selectedLogoSource: '',
        catLogoSelectionDialog:false,
        CatCreationDialog:false,
        CatImageName:"",
        searchcategory:"",
        isLoadingCats:false,
        CatTableHeader:
        [
            {text:"#",value:"counter",sortable:true,align:"right"},
            {text:"عنوان ",value:"nC_Title",sortable:true,align:"right"},
            {text:"ترتیب نمایش",value:"nC_SortField",sortable:true,align:"right"},
            {text:"عکس",value:"nC_Image",sortable:true,align:"right"},
            {text:"وضعیت",value:"nC_Status",sortable:true,align:"right"},
            {text:"عملیات",value:"operation",sortable:true,align:"right"},
        ],
        CatTableItems:
        [
        ],
        CatTitle:"",
        CatSortField:"",
        CatStatus:true,
        seo:{},
        originalItems:[],
        catLogoData:require('../../../assets/logo.png'),
        ALLOEWDIMGSIZE:{},
        LogoUrl:"",
        CatSeoModel:{},
        inEditingItem:false,
        EditSelectedItem:{},
        deleteItemId:0,
        deleteBtnLoading:false,
        ExportDataColumns:{
            "عنوان":"nC_Title",
            "ترتیب نمایش":"nC_SortField",
            "وضعیت":"nC_Status",
            "فایل لوگو":"nC_Image",
            "تنظیمات سئو":"nC_Seo",
        },
        EntityId:0,
        BoxType:7,
        SetPromotionBoxDialog:false
    }),
    async created()
    {
        let vm = this;
        vm.LogoUrl = ApiUrl.NoticesLogo;
       axios.interceptors.request.use((config) => {
            vm.isLoading = true;
            return config;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });

        axios.interceptors.response.use((response) => {
            vm.isLoading = false;
            return response;
        }, (error) => {
            vm.isLoading = false;
            return Promise.reject(error);
        });
       await this.loadCategories();
       this.ALLOEWDIMGSIZE = FSIZE.PRDCATIMGSIZE;
    },
    computed:{
        LANG(){
        return this.$store.getters.GetLang;
        }
    },
    watch:{
        LANG(nL,oL){
        this.loadCategories();
        }
    },
    methods:{
        LinkBoxSetting(eid)
        {
            let vm = this;
            vm.EntityId = eid;
            vm.SetPromotionBoxDialog=true;
        },
        ...mapActions([                  // Add this
        'setSeoForm'
        ]),
        LoadSeoFormData()
        {
            let vm = this;

            return vm.seo;
           
        },
        async DeleteItem()
        {
            let vm = this;
            vm.deleteBtnLoading = true;
            let Model = {};
            Model.NC_Id = vm.deleteItemId;
            await axios.post(ApiUrl.DeleteNoticesCat,Model)
            .then(async (res)=>{
                vm.deleteBtnLoading = false;
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    vm.ConfirmItemDeleteDialog = false;
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                vm.deleteBtnLoading = false;
                MSGHNDL.ERR(err);
            });
        },
        confirmDeleteItem(id)
        {
            let vm = this;
            vm.ConfirmItemDeleteDialog = true;
            vm.deleteItemId = id;
        },
        async ActiveItem(id)
        {
            let vm = this;
            let Model = {};
            Model.NC_Id = id;
            await axios.post(ApiUrl.ActiveNoticesCat,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        async DisableItem(id)
        {
            let vm = this;
            let Model = {};
            Model.NC_Id = id;
            await axios.post(ApiUrl.DisableNoticesCat,Model)
            .then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    MSGHNDL.OK(data.msg);
                    await vm.loadCategories();
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            })
            .catch((err)=>{
                MSGHNDL.ERR(err);
            });
        },
        cancelEditItem()
        {
            let vm = this;
            vm.CatCreationDialog = false;
            vm.CatTitle = "";
            vm.CatSortField = "";
            vm.CatStatus = false;
            vm.catLogoData = require('../../../assets/logo.png');
            vm.CatSeoModel = {
            title:"",
            url:"",
            keywords:"",
            image:"",
            description:"",
            othermeta:""
            };
            vm.inEditingItem = false;
            vm.EditSelectedItem = {};
        },
        editItem(item)
        {
            let vm = this;
            vm.CatCreationDialog = true;
            vm.CatTitle = item.nC_Title;
            vm.CatSortField = item.nC_SortField;
            vm.CatStatus = item.nC_Status;
            vm.catLogoData = vm.LogoUrl+item.nC_Image;
            vm.CatImageName = item.nC_Image;
            vm.CatSeoModel = (JSON.parse(item.nC_Seo));
            vm.inEditingItem = true;
            vm.EditSelectedItem = item;
        },
        async uploadEntityLogo()
        {
            let vm = this;
            await axios.post(ApiUrl.registerPcImg,{DataUrl:vm.catLogoData,Loc : "NOTICESCATIMG"}).then((res)=>{
                if(res.data.status)
                {
                    MSGHNDL.OK(res.data.msg);
                    vm.CatImageName = res.data.data;
                    vm.catLogoSelectionDialog = false;
                }
                else
                {
                    MSGHNDL.ERR(res.data.msg);
                }
            }).catch((err)=>{console.error(err);});
        },
        catLogoSelectedEvt(e)
        {
            let vm = this;
            let file = e.target.files[0];
            if(FTYPES.PRDCATLOGOFILETYPES.indexOf(file.type) == -1)
            {
                MSGHNDL.ERRFILEFORMAT();
                e.preventDefault();
                return;
            }
            if(file.size > 2000000)
            {
                MSGHNDL.ERRFILESIZE("2 مگابایت ");
                e.preventDefault();
                return;
            }
            MSGHNDL.CHKIMAGESIZE(file,0,0,0,0,1);
            
            if (FileReader) {
                var fr = new FileReader();
                fr.onload = function () {
                    vm.selectedLogoSource = fr.result;
                    vm.catLogoSelectionDialog = true;
                }
                fr.readAsDataURL(file);
            }
        },
        change({coordinates, canvas}) {
           this.catLogoData = canvas.toDataURL();
        },
        async loadCategories()
        {
            let vm = this;
            vm.isLoadingCats = true;

            await axios.post(ApiUrl.LoadNoticesCat+"/1/"+vm.LANG).then((res)=>{
                vm.isLoadingCats = false;
                let data = res.data;
                console.warn(data);
                if(data.status)
                {
                    vm.CatTableItems = data.data;
                    vm.originalItems = data.data;
                    console.warn(data.data);
                    
                }
            }).catch((err)=>{
                vm.isLoadingCats = false;
                console.error(err);
            });
        },
        async registerCategory()
        {
            let vm = this;
            let Model = {};
            Model.NC_Title = vm.CatTitle;
            Model.NC_SortField = parseInt(vm.CatSortField);
            Model.NC_Status = vm.CatStatus;
            Model.NC_Image = vm.CatImageName;
            var seoData = vm.LoadSeoFormData();
            Model.NC_Seo = JSON.stringify(seoData);
            Model.NC_SeoUrl = seoData.url;
            Model.NC_Type = 1;
            Model.Lang = vm.LANG;
            let url = ApiUrl.registerNoticesCat;
            if(vm.inEditingItem)
            {
                Model.NC_Id = vm.EditSelectedItem.nC_Id;
                url = ApiUrl.updateNoticesCat;
            }
            await axios.post(url,Model).then(async (res)=>{
                let data = res.data;
                if(data.status)
                {
                    vm.loadCategories();
                    vm.cancelEditItem();
                    MSGHNDL.OK(data.msg);
                }
                else
                {
                    MSGHNDL.ERR(data.msg);
                }
            }).catch((err)=>{console.warn(err)});
        },
        SeoChanged(data)
        {
            this.seo = data;
        }
    }
}
</script>